// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
// slick
import $ from 'jquery';
import 'third/jquery.slick.js';

class PromoLpDesignersSlider extends WebComponent {
  constructor(props) {
    super(props);
  }

  didMount() {
    const lang = document.getElementById('sectionMainLP').getAttribute('data-lang');
    const peopleList = document.querySelectorAll('.people-list__item');

    // Custom translations
    if (lang === 'de' && peopleList) {
      peopleList.forEach(person => {
        const name = person.querySelector('.people-list__item-title').innerHTML;
        const tag = person.querySelector('.people-list__item-tags');
        const perex = person.querySelector('.people-list__item-perex');
        const btn = person.querySelector('.people-list__item-btn');
        btn.innerHTML = 'Mehr';
        if (tag.innerHTML === 'Designers') {
          tag.innerHTML = 'Designer';
        }
        if (tag.innerHTML === 'Production') {
          tag.innerHTML = 'Herstellung';
        }
        if (name === 'Zdeněk Drobný') {
          perex.innerHTML = 'Glasbläsermeister und Träger des angesehenen Titels eines Ritters der Kunst und der Literatur.';
        }
        if (name === 'Jan Plecháč') {
          perex.innerHTML = 'Künstlerischer Direktor der Glasmanufaktur Moser und Gewinner des Preises Czech Grand Design 2023.';
        }
      });
    }

    if (document.documentElement.getAttribute('dir') === 'rtl') {
      $(this.element)
        .slick({
          rtl: true,
          mobileFirst: true,
          centerMode: true,
          infinite: false,
          arrows: true,
          dots: true,
          touchThreshold: 10,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 800,
          rows: 0,
          prevArrow: $('.promo-lp-designers-slider__item--prev'),
          nextArrow: $('.promo-lp-designers-slider__item--next'),
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                centerMode: false,
                slidesToShow: 2,
                centerPadding: 50,
              },
            },
          ],
        });
    } else {
      $(this.element)
        .slick({
          mobileFirst: true,
          centerMode: true,
          infinite: false,
          arrows: true,
          dots: true,
          touchThreshold: 10,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 800,
          rows: 0,
          prevArrow: $('.promo-lp-designers-slider__item--prev'),
          nextArrow: $('.promo-lp-designers-slider__item--next'),
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                centerMode: false,
                slidesToShow: 2,
                centerPadding: 50,
              },
            },
          ],
        });
    }

    // adjust height of the arrows
    $(this.element).on('setPosition', function(event, slick){
      const sliderHeight = $('.people-list__item-motive');
      slick.$nextArrow.css('height', sliderHeight.height());
      slick.$prevArrow.css('height', sliderHeight.height());
    });

    $(window)
      .resize(() => {
        $(this.element)
          .slick('resize');
      });
  }
}


export default PromoLpDesignersSlider;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/promoLP/PromoLpDesignersSlider.js